import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';

let ResultSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="AggregateMass" />
        <Field input={<TextOutput />} name="BinderContentFinal" />
      </ListFieldSection>
    </>
  );
};

const ResultSection = withInjectedProps(ResultSectionBase);

export { ResultSection };
export default ResultSection;
